import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';

// Shared sx for all supplier strategy DataGrids
export const supplierDataGridSx: SxProps<Theme> = {
  '& .MuiDataGrid-columnSeparator': { display: 'none' },
  '& .MuiDataGrid-columnHeaderTitle': { textTransform: 'none' },
  '& .MuiDataGrid-columnHeader': { borderRight: 'none' },
  '& .MuiDataGrid-cell': { borderRight: 'none', borderBottom: 'none' },
  '& .MuiDataGrid-row': { borderBottom: 'none' },
  '& .MuiDataGrid-row--borderBottom .MuiDataGrid-cell': {
    borderBottom: 'none'
  },
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: '1px solid',
    borderBottomColor: (theme: Theme) => theme.palette.divider
  }
};
